export const NAME = 'name';
export const TAG = 'tag';
export const RECIPIENT = 'recipient';
export const SUBJECT = 'subject';
export const BOT_VARIABLE_ID = 'variable_id';
export const VALUE = 'value';
export const ANSWER = 'answer';
export const URL = 'url';
export const BODY = 'body';
export const MESSAGE = 'message';
export const COMPANY_USER_IDS = 'company_user_ids_to_notify';
export const BUTTONS = 'buttons';
export const FOLLOW_UP = 'follow_up_type';

export const EMAIL_NOTIFICATION_FIELDS = [RECIPIENT, SUBJECT, BODY];

export const PUSH_NOTIFICATION_FIELDS = [MESSAGE, COMPANY_USER_IDS];
